import React from 'react';
import Jquery from 'jquery';
import 'bootstrap';
import { FUNDAMERICA_URL } from '../../config';

class FundAmerica extends React.Component {
  shouldComponentUpdate() {
    return false;
  }
  componentDidMount = () => {
    var x = document.createElement('SCRIPT');
    x.id = 'fa-invest-now-launcher';
    x.src = `${FUNDAMERICA_URL}`;

    document.body.appendChild(x);
    Jquery('button').on('click', function () {
      return false;
    });
  };

  render() {
    return (
      <button
        style={{ width: 'inherit', marginRight: 10 }}
        data-fa-invest-now='rWANH7Cu6EchcycRIC579qR2PRSvZwOW:MrlT0TCRREW19VuI2SItFQ'
        className='button small w-button'
      >
        Start Investment
      </button>
    );
  }
}

export default FundAmerica;



// WEBPACK FOOTER //
// ./src/components/ExternalInvestApi/FundAmerica.js